<template>
  <v-container fluid fill-height class="pa-0 ma-0 white" id="profile">
    <v-layout column class="pa-0 ma-0">
      <v-card class="elevation-0" style="margin: 1% 5%;">

        <v-card-text class="pa-0">
          
          <v-tabs v-model="selectedTab">
            <v-tab ripple href="#tab-1">
              List Promosi
            </v-tab>            
            <v-tab ripple href="#tab-2">
              Tambahkan Promosi
            </v-tab>
            
            <v-tabs-items v-model="selectedTab">
              <v-tab-item id="tab-1">
                <v-card>
                  <promosi-list></promosi-list>
                </v-card>
              </v-tab-item>
            
              <v-tab-item id="tab-2">
                <v-card flat>
                  <tambahkan-promosi></tambahkan-promosi>
                </v-card>
              </v-tab-item>
            
            </v-tabs-items>
          </v-tabs>          
        </v-card-text>

      </v-card>   
    </v-layout>
  </v-container>     
</template>

<script>
import { getUserById } from '@/api/user';

import VWidget from '@/components/VWidget';
import PromosiList from '@/components/promosi/PromosiList'
import TambahkanPromosi from '@/components/promosi/TambahkanPromosi'
export default {
  components: {
    VWidget,
    PromosiList,
    TambahkanPromosi,
  },
  data () {
    return {
      chat: null,
      selectedTab: null,
      status: false
    };
  },
  computed: {
   
    user () {
      let Origin = {
        name: 'DaftarCalonTutor',
        avatar: '',
      };
      let user = getUserById(this.$route.params.uuid);
      return Object.assign(Origin, user);
    }    
  },
};
</script>
